<app-spinner [blockedPanel]="blockedPanel"></app-spinner>

<app-add-asset-modal *ngIf="showAssetModal" (closeModalEvent)="closeModal($event)"></app-add-asset-modal>
<app-add-media-modal *ngIf="showListMediaModal" (closeModalEvent)="closeModal($event)" [mediaData]="mediaData"></app-add-media-modal>
<app-add-shipping-modal *ngIf="showShippingModal" [mediaData]="selectedMedia" [isFromAddMedia]="true" (closeModalEvent)="closeModal($event)"></app-add-shipping-modal>

<div class="row mt-2">
  <div class="col-3 d-flex justify-content-start align-items-start pr-0" style="width: 90%">
    <div class="kit-btn-group input-row flex-date-arrow calendar-none mb-0">
      <button class="btn btn-first mr-2 font-13 d-flex align-items-center" title="{{ 'Create' | translate }}" (click)="openListMediaModal()"><mat-icon>add</mat-icon> {{ "Create" }}</button>
    </div>
  </div>
  <div class="col-1"></div>
  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5 d-flex justify-content-start align-items-start"></div>
  <div class="col-3 d-flex align-items-start" style="justify-content: space-evenly !important">
    <div class="d-flex moreDetails align-items-center" id="openFIlterMenu" style="right: 0" (click)="isfiterClicked = !isfiterClicked" title="{{ 'Filter' | translate }}">
      <mat-icon>filter_list</mat-icon>
      <span class="notification-icon" style="position: absolute; right: -6px" *ngIf="mediaListCount > 0">{{ mediaListCount }}</span>

      {{ "Filter" | translate }}
    </div>
    <app-dynamic-filter id="openFIlterMenu" *ngIf="isfiterClicked" [filterSet]="filterMediaListSet" (filterArr)="seletedFilters($event)"></app-dynamic-filter>
  </div>
</div>

<div class="media-list-view">
  <div class="card-body px-0 setBoxShadow">
    <div class="hidden-columns" style="z-index: 10" id="hidden-columns" *ngIf="hiddenColumns">
      <h4 class="title font-roboto-cad font-bold txt-light-gog text-uppercase">{{ "Select Columns" | translate }}</h4>
      <ul>
        <li *ngFor="let c of columnsToRestore; let i = index">
          <span (click)="createCol(c, i)" class="d-block cursor-p">
            {{ c }}
          </span>
        </li>
      </ul>
    </div>

    <ngx-datatable class="table" [columns]="displayColumns" [rows]="allMediaList | globalSort : sortBy : sortValue | paginate : { itemsPerPage: size, currentPage: offset, totalItems: TotalCount }" [columnMode]="'standard'" [headerHeight]="50" [footerHeight]="30" [rowHeight]="60" [scrollbarH]="true">
      <ngx-datatable-column *ngFor="let column of displayColumns; let i = index" [name]="column.name" [prop]="column.prop" [width]="column.width" [sortable]="true">
        <ng-template ngx-datatable-header-template let-column="column" let-sort="sortFn" class="position-relative">
          <span class="t-show" (click)="sort()">
            <span class="cursor-p mr-5 d-inline-block" *ngIf="column.name == 'Media Title'" (click)="hiddenColumns = !hiddenColumns; stopPropagation($event)" id="hidden-columns">
              {{ "Add" | translate }}
            </span>
            <span class="datatable-header-cell-wrapper" style="margin-left: 20px">{{ column.name }}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span class="t-hide cursor-p text-danger font-14 float-right" *ngIf="column.name != 'Media Title'" (click)="deleteMediaColumn(column.name); stopPropagation($event)" title="{{ 'Remove' | translate }}"> &#10005; </span>
          </span>
        </ng-template>

        <ng-template let-row="row" let-value="value" let-j="rowIndex" ngx-datatable-cell-template>
          <ng-container *ngIf="column.prop === 'mediaTitle'">
            <div class="d-flex align-items-center" style="margin-top: -6px">
              <img [src]="row.thumbnail?.url || '/assets/img/demoImg.JPG'" (error)="onImageError($event)" (click)="listClickEvent(row)" class="cursor-p" style="object-fit: contain; width: 50px; height: 50px; margin-right: 10px" />

              <div class="flex-grow-1">
                <span *ngIf="!editing[j + '-mediaTitle'] && row.mediaTitle" title="{{ row.mediaTitle }}" (click)="editing[j + '-mediaTitle'] = true" class="leftAlign">
                  {{ row.mediaTitle }}
                </span>

                <span *ngIf="!editing[j + '-mediaTitle'] && !row.mediaTitle" class="txt-light-gog leftAlign" title="Click to edit" (click)="editing[j + '-mediaTitle'] = true">
                  {{ "Enter mediaTitle" | translate }}
                </span>

                <input *ngIf="editing[j + '-mediaTitle']" type="text" class="form-control form-control-sm resource-search" [value]="row.mediaTitle" autofocus (blur)="setMediaTitle($event.target.value, j, row); editing[j + '-mediaTitle'] = false" placeholder="{{ 'Enter Title' | translate }}" />
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="column.prop == 'uMId'">
            <span class="d-inline-block cursor-p">
              {{ row[column.prop] }}
            </span>
          </ng-container>

          <ng-container *ngIf="column.prop == 'language'">
            <app-dropdown-overlay [triggerText]="row.language ? row.language : 'Select Language'" [options]="dropdownMediaData?.languages" [translate]="true" (optionSelected)="setLanguageData($event, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'mediaType'">
            <app-dropdown-overlay [triggerText]="row.mediaType ? row.mediaType : 'Select Media Type'" [options]="dropdownMediaData?.mediaTypeList" labelKey="name" sortKey="name" [translate]="true" (optionSelected)="setMediaTypeListData($event, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'status'">
            <app-dropdown-overlay [triggerText]="row.status ? row.status : 'Select Status'" [options]="['Ingested', 'Not Available']" [translate]="true" (optionSelected)="setStatus($event, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'sanStatus'">
            <app-dropdown-overlay [triggerText]="row.sanStatus ? row.sanStatus : 'Select San Status'" [options]="['Ready', 'Not Available']" [translate]="true" (optionSelected)="setSanStatus($event, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'mediaSupportName'">
            <app-dropdown-overlay [triggerText]="row.mediaSupportName ? row.mediaSupportName : 'Select Support'" [options]="dropdownMediaData?.mediaSupportList" labelKey="name" sortKey="name" [translate]="true" (optionSelected)="setMediaSupportData($event, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'personId'">
            <app-dropdown-overlay [triggerText]="row.personId ? getUserName(row.personId) : 'Select User'" [options]="dropdownMediaData?.staffMemberList" labelKey="fullName" sortKey="fullName" [translate]="true" (optionSelected)="setUploaderData($event, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'formatName'">
            <app-dropdown-overlay [triggerText]="row.formatName ? row.formatName : 'Select Format'" [options]="dropdownMediaData?.formats" labelKey="name" sortKey="name" [translate]="true" (optionSelected)="setMediaFormat($event, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'mediaBitrateId'">
            <app-dropdown-overlay [triggerText]="row.mediaBitrateId ? getBitRateName(row.mediaBitrateId) : 'Select Bit-Rate'" [options]="dropdownMediaData?.mediaBitrateList" labelKey="name" sortKey="name" [translate]="true" (optionSelected)="setBitRateData($event, j, row)"> </app-dropdown-overlay>
          </ng-container>
          <!----     new fields              -->
          <ng-container *ngIf="column.prop == 'container'">
            <app-dropdown-overlay [triggerText]="row.container ? row.container : 'Select Container'" [options]="dropdownMediaData.mediaConfigDropDown?.container" labelKey="value" sortKey="value" [translate]="true" (optionSelected)="setContainer($event.value, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'resolution'">
            <app-dropdown-overlay [triggerText]="row.resolution ? row.resolution : 'Select Resolution'" [options]="resolutionLabels" [translate]="true" (optionSelected)="setResolution($event, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'aspectRatio'">
            <app-dropdown-overlay [triggerText]="row.aspectRatio ? row.aspectRatio : 'Select Aspect Ratio'" [options]="dropdownMediaData.mediaConfigDropDown?.aspectRatio" labelKey="value" sortKey="value" [translate]="true" (optionSelected)="setAspectRatio($event.value, j, row)">
            </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'frameRate'">
            <app-dropdown-overlay [triggerText]="row.frameRate ? row.frameRate : 'Select Frame Rate'" [options]="dropdownMediaData.mediaConfigDropDown?.frameRate" labelKey="value" sortKey="value" [translate]="true" (optionSelected)="setFrameRate($event.value, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'colorSpace'">
            <app-dropdown-overlay [triggerText]="row.colorSpace ? row.colorSpace : 'Select Color Space'" [options]="dropdownMediaData.mediaConfigDropDown?.colorSpace" labelKey="value" sortKey="value" [translate]="true" (optionSelected)="setColorSpace($event.value, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'fileType'">
            <app-dropdown-overlay [triggerText]="row.fileType ? row.fileType : 'Select File Type'" [options]="dropdownMediaData.mediaConfigDropDown?.fileType" labelKey="value" sortKey="value" [translate]="true" (optionSelected)="setFileType($event.value, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop === 'fileUrl'">
            <a [href]="row.fileUrl" target="_blank" rel="noopener noreferrer" class="d-inline-block cursor-p add-media-link">
              {{ row.fileUrl }}
            </a>
          </ng-container>

          <ng-container *ngIf="column.prop == 'audio'">
            <app-dropdown-overlay [triggerText]="row.audio ? row.audio : 'Select Audio'" [options]="dropdownMediaData.mediaConfigDropDown?.audio" labelKey="value" sortKey="value" [translate]="true" (optionSelected)="setAudio($event.value, j, row)"> </app-dropdown-overlay>
          </ng-container>

          <ng-container *ngIf="column.prop == 'date'">
            <span class="d-inline-block cursor-p">
              {{ row[column.prop] | date : "yyyy-MM-dd" }}
            </span>
          </ng-container>

          <ng-container *ngIf="column.prop == 'duration'">
            <!-- View Mode -->
            <span title="{{ row.duration }}" *ngIf="!editing[j + '-duration']" (click)="editing[j + '-duration'] = true" class="leftAlign">
              {{ formatDuration(row.duration) }}
            </span>

            <!-- Placeholder when empty -->
            <span class="txt-light-gog leftAlign" title="Click to edit" (click)="editing[j + '-duration'] = true" *ngIf="!editing[j + '-duration'] && (!row.duration || row.duration === '')">
              {{ "Enter duration" | translate }}
            </span>

            <!-- Edit Mode with Masked Input -->
            <input
              autofocus
              type="text"
              class="form-control resource-search"
              (input)="onDurationInput($event.target.value)"
              (blur)="setDuration($event.target.value, j, row); editing[j + '-duration'] = false"
              [value]="row.duration"
              [textMask]="{ mask: mask }"
              *ngIf="editing[j + '-duration']"
              placeholder="{{ 'Enter duration' | translate }}" />
          </ng-container>

          <ng-container *ngIf="column.prop == 'mediaVersion'">
            <span title="{{ row.mediaVersion }}" *ngIf="!editing[j + '-mediaVersion'] && row.mediaVersion != null && row.mediaVersion != ''" (click)="editing[j + '-mediaVersion'] = true" class="leftAlign">
              {{ row.mediaVersion }}
            </span>
            <span class="txt-light-gog leftAlign" title="click to edit" (click)="editing[j + '-mediaVersion'] = true" *ngIf="!editing[j + '-mediaVersion'] && (row.mediaVersion == null || row.mediaVersion == '')">
              {{ "Enter mediaVersion" }}
            </span>
            <input autofocus type="text" class="form-control resource-search" (blur)="setMediaVersionData($event.target.value, j, row); editing[j + '-mediaVersion'] = false" [value]="row.mediaVersion" *ngIf="editing[j + '-mediaVersion']" placeholder="{{ 'Enter version' | translate }}" />
          </ng-container>

          <ng-container *ngIf="column.prop == 'add shipping'">
            <a href="javascript:void(0);" class="add-media-link" (click)="openShippingForm(row)" title="{{ 'Add Shipping' | translate }}">
              {{ "Add shipping" | translate }}
            </a>
          </ng-container>

          <ng-container *ngIf="column.prop == 'add vault'">
            <a href="javascript:void(0);" class="add-media-link" (click)="openMediaVaultForm(row)" title="{{ 'Add vault' | translate }}">
              {{ "Add vault" | translate }}
            </a>
          </ng-container>

          <!-- ✅ New: Copy & Print using Material Icons -->
          <ng-container *ngIf="column.prop == 'copy print'">
            <div class="icon-actions">
              <button mat-icon-button (click)="onCopy(row)" matTooltip="Copy">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button mat-icon-button (click)="onPrint(row)" matTooltip="Print">
                <mat-icon>ios_share</mat-icon>
              </button>
            </div>
          </ng-container>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>
<pagination-controls class="my-pagination" (pageChange)="pageChangeListView($event)" style="text-align: center; font-size: 14px"></pagination-controls>
